import { ReactNode, createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getAccessControl } from "../services/AccessControl";
import { getAllowDenyStatus } from "../services/AllowStatus";
import Jumper from "../components/Jumper";

interface AccessControl {
    id: number;
    roleId: number;
    groupName: string;
    section: string;
    action: string;
    allowDenyStatusId: number;
}

const AccessControlContext = createContext({});

export const AccessControlProvider = ({ children }: { children: ReactNode }) => {
    const [userRoleId, setUserRoleId] = useState<string>(Cookies.get("roleId-velox-charter") || "");
    const [permissions, setPermissions] = useState<{ [key: string]: boolean }>({});
    const [loading, setLoading] = useState<boolean>(true);

    const token = Cookies.get("token-velox-charter");
    const role = Cookies.get("role-velox-charter") || '';

    useEffect(() => {
        if (role.toLowerCase() === "admin") {
            setPermissions({});
            setLoading(false);
            return;
        }

        const fetchPermissions = async () => {
            setLoading(true);

            if (!userRoleId || !token) {
                setLoading(false);
                return;
            }

            try {
                const accessResponse: any = await getAccessControl(
                    "access_controls/",
                    { roleId: userRoleId },
                    token.toString()
                );

                const accessControlData: AccessControl[] =
                    accessResponse?.data ?? accessResponse;

                const statusResponse: any = await getAllowDenyStatus();

                const allowStatusId =
                    statusResponse?.data?.find(
                        (item: any) => item.name === "Allow All"
                    )?.id;

                const newPermissions: { [key: string]: boolean } = {};

                accessControlData.forEach((item: AccessControl) => {
                    const normalizedSection = item.section
                        .replace(/\s+/g, "")
                        .replace(/-/g, "")
                        .toLowerCase();

                    newPermissions[normalizedSection] =
                        item.allowDenyStatusId === allowStatusId;
                });

                setPermissions(newPermissions);
            } catch (error) {
                console.error("Error fetching permissions:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();

    }, [userRoleId, role, token]);

    return (
        <AccessControlContext.Provider
            value={{ permissions, setPermissions, userRoleId, setUserRoleId }}
        >
            {loading ? <Jumper /> : children}
        </AccessControlContext.Provider>
    );
};

export default AccessControlContext;
